import * as types from '../mutation-types'
import { api } from '@/modules/api/index'

const state = {
  testimonials: []
}

const getters = {
  getTestimonials: state => state.testimonials
}

const actions = {
  async fetchTestimonials ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.testimonials.getAll())
      commit(types.SET_TESTIMONIALS_LIST, data)
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to fetch testimonial')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateTestimonial ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.testimonials.updateTestimonial(), payload)
      this.dispatch('showResultSuccessMessage', 'Testimonial updated')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to update testimonial')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteTestimonial ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.testimonials.deleteTestimonial(id))
      this.dispatch('showResultSuccessMessage', 'Testimonial deleted')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to delete testimonial')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createTestimonial ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.testimonials.createTestimonial(), payload)
      this.dispatch('showResultSuccessMessage', 'Testimonial created')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to create testimonial')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_TESTIMONIALS_LIST] (state, { testimonials }) {
    state.testimonials = testimonials
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/testimonials.js